import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedRoute: 0,
  featureEnabled: true,
};

const menuSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setSelectedRoute: (state, action) => {
      state.selectedRoute = action.payload;
    },
    toggleFeature: (state) => {
      state.featureEnabled = !state.featureEnabled;
    },
  },
});

// Action creators are generated for each case reducer function
const { setSelectedRoute, toggleFeature } = menuSlice.actions;

export { menuSlice, setSelectedRoute, toggleFeature };
export default menuSlice.reducer;
